<template>
    <div>
        <b-modal
            ref="rgpdModal"
            :title="$t('pages.forms.common.gdpr.title')"
            title-tag="h5"
            :hide-footer="true"
        >
            <p>{{ $t("pages.forms.common.gdpr.legal-text") }}</p>
        </b-modal>

        <b-form-group
            label-for="rgpd"
            style="justify-content: center; display: flex;"
        >
            <div class="checkbox">
                <input
                    id="rgpd"
                    type="checkbox"
                    v-model="conditionsAccepted"
                    :value="true"
                    @change="update"
                />
                <label for="rgpd"
                    >{{ $t("pages.forms.common.gdpr.s1") }}
                    <a @click="showModal" :centered="true" href="#"
                        >{{ $t("pages.forms.common.gdpr.s2") }} </a
                    >.
                </label>
            </div>
        </b-form-group>
    </div>
</template>

<script>
export default {
    data() {
        return {
            conditionsAccepted: this.value
        };
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update() {
            this.$emit("input", this.conditionsAccepted);
        },
        showModal() {
            this.$refs["rgpdModal"].show();
        }
    }
};
</script>

<style scoped></style>
